module.exports = __webpack_public_path__ + "static/media/awesome-industry.f3bb8830.svg";